import { Component, OnInit, Input, TemplateRef, EventEmitter, Output } from '@angular/core';
import { ToastService } from '../../../shared/providers/toast.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { LoaderService } from '../../../shared/providers/loader.service';
import { BrokerageManagerService } from '../../../shared/providers/brokerage-manager.service';
import { EditPropertyDeatilsModel, PropertySalesInputModel } from '../../../shared/models/SavePropertyInputModel';
import { PropertyManagementService } from '../../../shared/providers/property-management.service';
import { CommonService } from '../../../shared/providers/common.service';
import { ILookUp } from '../../../shared/models/LookUpOutputModel';
import { ValidationService } from '../../../shared/providers/validation.service';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { FileUploadService } from '../../../shared/providers/fileupload.service';
import { IFileUpload, IPropertyFileUpload } from '../../../shared/models/fileupload';
import { PropertyStatus } from '../../../shared/enum/enum';
import { IPropertySearchCriteria } from '../../../shared/models/propertysearchcriteria';
import { PropertyListingService } from '../../../shared/providers/property-listing.service';
@Component({
  selector: 'app-quick-edit-property',
  templateUrl: './quick-edit-property.component.html'
})

export class QuickEditPropertyComponent implements OnInit {

  constructor(private modalServiceSales: BsModalService, public authService: AuthenticationService, private _toastService: ToastService, private _propertyManagementService: PropertyManagementService, private _brokerageManagerService: BrokerageManagerService, private _loaderService: LoaderService, private _commonService: CommonService, public validationService: ValidationService, private _fileUploadService: FileUploadService, private _propertyListingService: PropertyListingService) { }
  @Input() modalRefsales: BsModalRef;
  @Input() quickEditDetails: any[];
  model: EditPropertyDeatilsModel;
  @Input() selectedPropertyId: string;
  @Input() isDataEntryProperty: boolean;
  propertyStatusList: ILookUp[];
  loggedUserDetails: any;
  viewSoldDetailsLink = false;
  currentSalesDetails: PropertySalesInputModel;
  capRateMessage: string = "";
  state: string;
  city: string;
  disableCapRate: boolean = false;
  capratetext = "Cap Rate";
  brokerage: number;
  @Output() closeModal = new EventEmitter();
  roleId = 1;
  FileUpload = {} as IFileUpload;
  editIndex: number;
  dataEntryPropertyStatusId = 0 as number;
  propertyStatus = PropertyStatus;
  ngOnInit() {
    this.model = {
      Id: 0,
      Guid: '00000000-0000-0000-0000-000000000000',
      LoginUserId: 0,
      TenantId: 0,
      TenantTradeName: null,
      TenantName: null,
      IsFranchisee: true,
      SPRatingId: null,
      MoodyRatingId: null,
      FitchRatingId: null,
      NoOfUnits: null,
      Guarantor: 'Corporate',
      Address: null,
      StateId: null,
      CityId: null,
      Zip: null,
      BrokerList: [],
      IsFeatured: false,
      YearBuilt: null,
      Renovated: null,
      PropertyTypeId: null,
      SubCategoryId: null,
      BuildingSize: null,
      Land: null,
      PropertyForId: null,
      Description: null,
      NOI: null,
      LeasePricePSF: null,
      OriginalLeaseTerm: null,
      LeaseCommencementDate: null,
      LeaseExpiration: null,
      RentEscalationPercentage: null,
      RentEscalationPeriod: null,
      OptionNumber: null,
      OptionLength: null,
      IsShowPrice: false,
      LeaseStructureId: null,
      OwnershipTypeId: null,
      Price: null,
      PricePSF: null,
      CapRate: null,
      Latitude: null,
      Longitude: null,
      VideoUrl: null,
      DateOnMarket: new Date(),
      InvestmentHighlights: [],
      ContactOrBrokerInfo: [],
      PropertySource: null,
      PropertySalesInputModel: [],
      BrokerageId: null,
      BrokersId: [],
      LiveListingId: null,
      GuarantorId: null,
      CharacteristicsId: [],
      DisplayName: null,
      ShowDisplayName: true,
      PropertyTypeList: [],
      PropertyTypeSubcategoryList: [],
      PropertyLeasingHistoryInputModel: [],
      PropertySellers: [],
      MetatagsId: [],
      UnpricedText: null,
      CapRateText: null,
      Unpriced:null
    };
    this.capRateMessage = '';
    this.disableCapRate = false;
    this.resetSalesDetails();
    this.loggedUserDetails = this.authService.user;
    this.roleId = this.loggedUserDetails.RoleId;
    this.model.LoginUserId = this.loggedUserDetails.Id;
    // Loads the property categories
    this._commonService.getPropertyStatus().subscribe(response => {
      this.propertyStatusList = response.map(o => {
        return {
          id: o.Id, description: o.Description
        };
      });

      //this.propertyStatusList = this.propertyStatusList.filter(x => x.id !== 358);
      this.model.PropertyStatusId = 351;
    });

    this.loadPropertyDetails(this.selectedPropertyId);
    this.state = this.quickEditDetails[0];
    this.city = this.quickEditDetails[1];
    this.brokerage = this.quickEditDetails[2];
    if (this.isDataEntryProperty) {
      this.viewSoldDetailsLink = false;
    }

  }
  close($event) {
    console.log(this.modalRefsales);
    if (this.modalRefsales) {
      this.modalRefsales.hide();  // Hide the modal
    }
  }
  SaveProperty(mode?: number) {
    if (mode == 1) {
      this.model.IsSaveOnly = true;
      this.model.SaveAsDraft = true;
      this.model.DataEntryPropertyStatusId = this.propertyStatus.Draft //Draft
    }
    else if (mode == 2) {
      this.model.SaveAsDraft = false;
      this.model.IsSaveOnly = false;
      this.model.DataEntryPropertyStatusId = this.model.DataEntryPropertyStatusId == this.propertyStatus.Draft ? this.propertyStatus.PendingApproval : this.model.DataEntryPropertyStatusId;
    }
    else if (mode == 3) {
      this.model.SaveAsDraft = false;
      this.model.IsSaveOnly = true;
    }

    if (this.model.DataEntryPropertyStatusId == 357 && !this.checkValidation()) {
      this._toastService.addToast({
        title: 'Unable to save changes',
        msg: 'Some fields still have invalid data or some mandatory fields are missing.',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'warning'
      });

      return false;
    }

    let invalid = false;
    if (this.model.CapRate > 100) {
      invalid = true;
      this.capRateMessage = "Cap Rate cannot be greater than 100";
    }
    if (!invalid) {
      this._loaderService.display(true);
      let head = this.model.IsPortfolio ? "Portfolio" : "Property";
      if (this.isDataEntryProperty) {
        this._propertyManagementService.saveDataEntryProperty(this.model).subscribe(response => {
          this.savePropertySaleHistory(this.model.PropertySalesInputModel.filter(x => x.Index == 1)[0], response["Object"].PropertySalesInputModel.filter(x => x.Index == 1)[0], 310)
          this._toastService.addToast({ title: 'Success', msg: head + ' updated successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
          this._loaderService.display(false);
          this.closeModal.emit(true);
        });
      }
      else {
        this._propertyManagementService.saveProperty(this.model).subscribe(response => {
          this.savePropertySaleHistory(this.model.PropertySalesInputModel.filter(x => x.Index == 1)[0], response["Object"].PropertySalesInputModel.filter(x => x.Index == 1)[0], 309)
          this._toastService.addToast({ title: 'Success', msg: head + ' updated successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
          this._loaderService.display(false);
          this.closeModal.emit(true);
        });
      }
    }

  }

  closeModel($event) {
    this.closeModal.emit(true);
  }
  resetSalesDetails() {
    this.currentSalesDetails = {
      Id: 0,
      PropertyId: 0,
      SaleDate: null,
      SalePrice: null,
      SaleCapRate: null,
      SalePSF: null,
      BrokerageId: null,
      AutoCalcCapRate: null,
      AutoCalcPSF: null,
      AutoPopulated: null,
      NOI: null,
      BuildingSize: null,
      DateOnMarket: null,
      YearOnMarket: null,
      MonthOnMarket: null,
      DayOnMarket: null,
      AskingPrice: null,
      AskingCapRate: null,
      DiscountToAsking: null,
      BuyerName: null,
      BuyerBrokerageName: null,
      BuyerBrokerName: null,
      SellerName: null,
      SellerBrokerageName: null,
      SellerBrokerName: null,
      RemainingTermYear: null,
      RemainingTermMonth: null,
      RemainingTermDay: null,
      Is1031ExchangeBuyer: false,
      SaleCharacteristicsId: null,
      AutoCalcDiscount: null,
      LTV: null,
      InterestRate: null,
      Amortization: null,
      Term: null,
      SalesNotes: null,
      GuarantorId: null,
      SPRatingId: null,
      MoodyRatingId: null,
      FitchRatingId: null,
      LeaseStructureId: null,
      RentEscalationPercentage: null,
      RentEscalationPeriod: null,
      OptionNumber: null,
      OptionLength: null,
      SalesNOI: null,
      BuyerBrokerageId: null
    };
  }

  openSolidDetails(template: TemplateRef<any>, classes, StatusValue) {

    var openModelStatus = false;
    if (this.propertyStatusList.find(data => data.id === StatusValue).description.toLowerCase() == 'sold') {
      openModelStatus = true
    }

    if (StatusValue == 351) {
      this.model.DateOnMarket = new Date();
    }

    if (openModelStatus) {
      this.viewSoldDetailsLink = true;
      ////this.currentSalesDetails.BrokerageId = this.brokerageId != undefined && this.brokerageId != null ? this.brokerageId : 0;
      if (this.model.PropertySalesInputModel.length == 0) {
        this._propertyManagementService.GetSaleInfoFromOffers(this.model.Guid).subscribe(res => {
          if (Number(res["PropertyId"]) != 0) {
            this.currentSalesDetails.SaleDate = this.validationService.convertUTCDateToLocalDate(res["SaleDate"]);
            this.currentSalesDetails.SalePSF = Number(res["SalePrice"]) / Number(this.model.BuildingSize);
            this.currentSalesDetails.SaleCapRate = (Number(this.model.NOI) / Number(res["SalePrice"])) * 100;
            this.currentSalesDetails.SalePrice = res["SalePrice"];

            this.currentSalesDetails.AutoPopulated = true;
          }
          this.currentSalesDetails.NOI = this.model.NOI;
          this.currentSalesDetails.BuildingSize = this.model.BuildingSize;
          this.modalRefsales = this.modalServiceSales.show(template, { class: classes });
          console.log(this.modalRefsales);
        });
      }
      else {
        if (this.model.PropertySalesInputModel.length != 0) {
          //Math.max.apply(Math, this.model.PropertySalesInputModel.map(function (o) { return o.SaleDate; }))
          var data = this.model.PropertySalesInputModel.reduce((prev, current) => (prev.SaleDate > current.SaleDate) ? prev : current)
          this.editIndex = this.model.PropertySalesInputModel.findIndex(x => x.Id == data.Id);
          this.currentSalesDetails = Object.assign({}, data);
        }
        if (this.currentSalesDetails.SaleDate != null) {
          this.currentSalesDetails.SaleDate = this.validationService.convertUTCDateToLocalDate(this.currentSalesDetails.SaleDate);
        }
        this.currentSalesDetails.NOI = this.model.NOI;
        this.currentSalesDetails.BuildingSize = this.model.BuildingSize;
        this.modalRefsales = this.modalServiceSales.show(template, { class: classes });
        console.log(this.modalRefsales);
      }

    }
    else {
      this.viewSoldDetailsLink = false;
    }
  }

  addSalesDetails(salesDetalsValue: PropertySalesInputModel) {
    if (this.editIndex != null && this.editIndex >= 0) {
      salesDetalsValue.Index = 1;
      this.model.PropertySalesInputModel[this.editIndex] = salesDetalsValue;
    }
    else {
      salesDetalsValue.Index = 1;
      this.model.PropertySalesInputModel.push(salesDetalsValue);
    }

    this.modalRefsales.hide();
    this.viewSoldDetailsLink = true;
  }

  private utcify(date: Date): Date {
    if (date) {
      return new Date(date.toUTCString());
    } else {
      return new Date();
    }
  }

  updateCapRate() {
    if (this.model.AutoCalcCapRate) {
      this.model.CapRate = (this.model.NOI / this.model.Price) * 100;
    }
    this.validateCapRate();
    if (this.model.IsPortfolio) {
      this.model.AutoCalcPrice = false
    }
  }
  validateCapRate() {
    if (this.model.CapRate > 100) {
      this.capRateMessage = " Cap Rate cannot be greater than 100";
    }
    else {
      this.capRateMessage = "";
    }
  }

  loadPropertyDetails(id: string) {
    this._loaderService.display(true);
    if (this.isDataEntryProperty) {

      this._propertyManagementService.getDataEntryPropertyDetails(id).subscribe(x => {
        this.model.Address = x.Address;
        this.model.BuildingSize = x.BuildingSize;
        this.model.CapRate = x.OnlyZCF ? null : x.CapRate;
        this.model.BrokerageId = x.BrokerageId;
        this.model.BrokersId = x.BrokersId;
        //this.brokerslist = x.BrokerList;
        this.model.DateOnMarket = this.validationService.convertUTCDateToLocalDate(x.DateOnMarket);
        this.model.Description = x.Description;
        this.model.PropertySource = x.PropertySource;
        this.model.FitchRatingId = x.FitchRatingId;
        this.model.Guarantor = x.Guarantor;
        this.model.Guid = x.Guid;
        this.model.Id = x.Id;
        this.model.IsFeatured = x.IsFeatured;
        this.model.IsFranchisee = x.IsFranchisee;
        this.model.IsShowPrice = x.IsShowPrice;
        this.model.Land = x.Land;
        this.model.Latitude = x.Latitude;
        this.model.LeaseCommencementDate = this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate);
        this.model.LeaseExpiration = this.validationService.convertUTCDateToLocalDate(x.LeaseExpiration);
        this.model.LeasePricePSF = x.LeasePricePSF;
        this.model.LeaseStructureId = x.LeaseStructureId;
        this.model.Longitude = x.Longitude;
        this.model.MoodyRatingId = x.MoodyRatingId;
        this.model.NOI = this.validationService.commaFormat(x.NOI);
        this.model.NoOfUnits = x.NoOfUnits;
        this.model.OptionLength = x.OptionLength;
        this.model.OptionNumber = x.OptionNumber;
        this.model.OriginalLeaseTerm = x.OriginalLeaseTerm;
        this.model.OwnershipTypeId = x.OwnershipTypeId;
        this.model.Price = this.validationService.commaFormat(x.Price);
        this.model.PricePSF = x.PricePSF;
        this.model.PropertyForId = x.PropertyForId;
        this.model.PropertyStatusId = x.PropertyStatusId;
        this.model.DataEntryPropertyStatusId = x.DataEntryPropertyStatusId;
        this.dataEntryPropertyStatusId = x.DataEntryPropertyStatusId;
        this.capratetext = x.OnlyZCF ? "ZCF" : "Cap Rate";

        this.disableCapRate = (x.OnlyZCF || x.Unpriced ) ? true : false;
        this.model.PropertyTypeId = x.PropertyTypeId;

        this.model.SubCategoryId = x.SubCategoryId;

        this.model.Renovated = x.Renovated;
        this.model.RentEscalationPercentage = x.RentEscalationPercentage;
        this.model.RentEscalationPeriod = x.RentEscalationPeriod;
        this.model.SPRatingId = x.SPRatingId;
        this.model.StateId = x.StateId;
        this.model.CityId = x.CityId;
        this.model.TenantId = x.TenantId;
        this.model.TenantName = x.TenantName;
        this.model.TenantTradeName = x.TenantTradeName;
        this.model.VideoUrl = x.VideoUrl;
        this.model.YearBuilt = x.YearBuilt;
        this.model.Zip = x.Zip;
        this.model.DueDiligenceReqApproval = x.DueDiligenceReqApproval;
        this.model.OfferMemoReqApproval = x.OfferMemoReqApproval;
        this.model.ConfidentialityAgreement = x.ConfidentialityAgreement;
        this.model.DDConfidentialityAgreement = x.DDConfidentialityAgreement;
        this.model.IsComp = x.IsComp;
        this.model.IsArchive = x.IsArchive;
        this.model.IsSourceChanged = x.IsSourceChanged;
        this.model.TenantNameText = x.TenantNameText;
        this.model.GuarantorName = x.GuarantorName;
        this.model.Unpriced = x.Unpriced;
        this.model.UnpricedText = x.Unpriced ? 'Unpriced' : '';
        if (!x.IsPortfolio) {
          if (x.PropertySalesInputModel.length != 0) {
            x.PropertySalesInputModel.forEach(item => {
              item.SaleDate = this.validationService.convertUTCDateToLocalDate(item.SaleDate);
              item.DateOnMarket = this.validationService.convertUTCDateToLocalDate(item.DateOnMarket);
              this.model.PropertySalesInputModel.push(item);
            })
          }

          if (this.viewSoldDetailsLink == false) {
            let CurrentPropertyStatusId = x.PropertyStatusId;
            if (CurrentPropertyStatusId != 355) {
              if (this.propertyStatusList.find(data => data.id === CurrentPropertyStatusId).description.toLowerCase() == 'sold') {
                this.viewSoldDetailsLink = true
              }
            }
          }
        }
        this._loaderService.display(false);
        this.model.AutoCalcCapRate = x.AutoCalcCapRate;
        this.model.DisplayName = x.DisplayName;
        this.model.ShowDisplayName = x.ShowDisplayName;
        this.model.CharacteristicsId = x.CharacteristicsId;
        this.model.PropertyTypeList = x.PropertyTypeList;
        this.model.PropertyTypeSubcategoryList = x.PropertyTypeSubcategoryList;
        this.model.IsRentTermAutoCalc = x.IsRentTermAutoCalc;
        this.model.IsShowRentSchedule = x.IsShowRentSchedule;
        this.model.PropertyRentTerm = x.PropertyRentTerm;
        this.model.GuarantorId = x.GuarantorId;
        this.model.PropertySellers = x.PropertySellers;

        if (this.model.PropertyForId == 602) {
          if (this.propertyStatusList.length > 0) {
            this.propertyStatusList.splice(this.propertyStatusList.findIndex(x => x.id == 349), 1);
            this.propertyStatusList.splice(this.propertyStatusList.findIndex(x => x.id == 350), 1);
          }
        }
        // portfolio
        this.model.PortfolioOriginalLeaseTerm = x.PortfolioOriginalLeaseTerm;
        this.model.PortfolioRemainingLeaseTerm = x.PortfolioRemainingLeaseTerm;
        this.model.IsPortfolio = x.IsPortfolio;
        this.model.AutoCalcPrice = x.AutoCalcPrice;
        this.model.PortfolioPropertyIds = x.PortfolioPropertyIds;
        this.model.OwnershipTypeIds = x.OwnershipTypeIds;
        this.model.LeaseStructureIds = x.LeaseStructureIds;
        this.model.NumberOfLocations = x.NumberOfLocations;
        this.model.NumberOfProperties = x.NumberOfProperties;
        this.model.InvestmentHighlights = x.InvestmentHighlights;
        this.model.AutoCalcCommencement = x.AutoCalcCommencement == null ? true : x.AutoCalcCommencement;
        this.model.AutoCalcLeaseExpiration = x.AutoCalcLeaseExpiration == null ? true : x.AutoCalcLeaseExpiration;
        this.model.AutoCalcLeaseType = x.AutoCalcLeaseType == null ? true : x.AutoCalcLeaseType;
        this.model.AutoCalcNumberOfLocations = x.AutoCalcNumberOfLocations == null ? true : x.AutoCalcNumberOfLocations;
        this.model.AutoCalcNumberOfProperties = x.AutoCalcNumberOfProperties == null ? true : x.AutoCalcNumberOfProperties;
        this.model.AutoCalcOptionLength = x.AutoCalcOptionLength == null ? true : x.AutoCalcOptionLength;
        this.model.AutoCalcOptionNumber = x.AutoCalcOptionNumber == null ? true : x.AutoCalcOptionNumber;
        this.model.AutoCalcOriginalLeaseTerm = x.AutoCalcOriginalLeaseTerm == null ? true : x.AutoCalcOriginalLeaseTerm;
        this.model.AutoCalcOwnershipType = x.AutoCalcOwnershipType == null ? true : x.AutoCalcOwnershipType;
        this.model.AutoCalcPortfolioSubcategory = x.AutoCalcPortfolioSubcategory == null ? true : x.AutoCalcPortfolioSubcategory;
        this.model.AutoCalcPortfolioType = x.AutoCalcPortfolioType == null ? true : x.AutoCalcPortfolioType;
        this.model.AutoCalcRemainingLeaseTerm = x.AutoCalcRemainingLeaseTerm == null ? true : x.AutoCalcRemainingLeaseTerm;
        this.model.AutoCalcRent = x.AutoCalcRent == null ? true : x.AutoCalcRent;
        this.model.AutoCalcRentalIncrease = x.AutoCalcRentalIncrease == null ? true : x.AutoCalcRentalIncrease;
        this.model.AutoCalcTenantType = x.AutoCalcTenantType == null ? true : x.AutoCalcTenantType;
        this.model.TenantTypeId = x.TenantTypeId;
        this.model.PropertySellers = x.PropertySellers;
        this.model.AutoCalcPrice = x.AutoCalcPrice == null ? true : x.AutoCalcPrice;
        this.model.AutoCalcBuildingSize = x.AutoCalcBuildingSize == null ? true : x.AutoCalcBuildingSize;
        this.model.IsOfferOnAllProperties = x.IsOfferOnAllProperties;

        if (x.IsPortfolio) {
          this.loadPortfolioProperties();
        }
      });
    }
    else {
      this._propertyManagementService.getPropertyDetails(id).subscribe(x => {

        this.model.Address = x.Address;
        this.model.BuildingSize = x.BuildingSize;
        this.model.CapRate = x.OnlyZCF ? null : x.CapRate;
        this.model.BrokerageId = x.BrokerageId;
        this.model.BrokersId = x.BrokersId;
        //this.brokerslist = x.BrokerList;
        this.model.DateOnMarket = this.validationService.convertUTCDateToLocalDate(x.DateOnMarket);
        this.model.Description = x.Description;
        this.model.PropertySource = x.PropertySource;
        this.model.FitchRatingId = x.FitchRatingId;
        this.model.Guarantor = x.Guarantor;
        this.model.Guid = x.Guid;
        this.model.Id = x.Id;
        this.model.IsFeatured = x.IsFeatured;
        this.model.IsFranchisee = x.IsFranchisee;
        this.model.IsShowPrice = x.IsShowPrice;
        this.model.Land = x.Land;
        this.model.Latitude = x.Latitude;
        this.model.LeaseCommencementDate = this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate);
        this.model.LeaseExpiration = this.validationService.convertUTCDateToLocalDate(x.LeaseExpiration);
        this.model.LeasePricePSF = x.LeasePricePSF;
        this.model.LeaseStructureId = x.LeaseStructureId;
        this.model.Longitude = x.Longitude;
        this.model.MoodyRatingId = x.MoodyRatingId;
        this.model.NOI = this.validationService.commaFormat(x.NOI);
        this.model.NoOfUnits = x.NoOfUnits;
        this.model.OptionLength = x.OptionLength;
        this.model.OptionNumber = x.OptionNumber;
        this.model.OriginalLeaseTerm = x.OriginalLeaseTerm;
        this.model.OwnershipTypeId = x.OwnershipTypeId;
        this.model.Price = this.validationService.commaFormat(x.Price);
        this.model.PricePSF = x.PricePSF;
        this.model.PropertyForId = x.PropertyForId;
        this.model.PropertyStatusId = x.PropertyStatusId;
        this.model.DataEntryPropertyStatusId = x.DataEntryPropertyStatusId;
        this.capratetext = x.OnlyZCF ? "ZCF" : "Cap Rate";
        this.disableCapRate = x.OnlyZCF ? true : false;
        this.model.PropertyTypeId = x.PropertyTypeId;

        this.model.SubCategoryId = x.SubCategoryId;

        this.model.Renovated = x.Renovated;
        this.model.RentEscalationPercentage = x.RentEscalationPercentage;
        this.model.RentEscalationPeriod = x.RentEscalationPeriod;
        this.model.SPRatingId = x.SPRatingId;
        this.model.StateId = x.StateId;
        this.model.CityId = x.CityId;
        this.model.TenantId = x.TenantId;
        this.model.TenantName = x.TenantName;
        this.model.TenantTradeName = x.TenantTradeName;
        this.model.VideoUrl = x.VideoUrl;
        this.model.YearBuilt = x.YearBuilt;
        this.model.Zip = x.Zip;
        this.model.DueDiligenceReqApproval = x.DueDiligenceReqApproval;
        this.model.OfferMemoReqApproval = x.OfferMemoReqApproval;
        this.model.ConfidentialityAgreement = x.ConfidentialityAgreement;
        this.model.DDConfidentialityAgreement = x.DDConfidentialityAgreement;
        this.model.IsComp = x.IsComp;
        this.model.IsArchive = x.IsArchive;
        this.model.IsSourceChanged = x.IsSourceChanged;
        this.model.Unpriced = x.Unpriced;
        this.model.UnpricedText = x.Unpriced ? 'Unpriced' : '';
        if (!x.IsPortfolio) {
          if (x.PropertySalesInputModel.length != 0) {
            x.PropertySalesInputModel.forEach(item => {
              item.SaleDate = this.validationService.convertUTCDateToLocalDate(item.SaleDate);
              item.DateOnMarket = this.validationService.convertUTCDateToLocalDate(item.DateOnMarket);
              this.model.PropertySalesInputModel.push(item);
            })
          }
          if (this.viewSoldDetailsLink == false) {
            let CurrentPropertyStatusId = x.PropertyStatusId;
            if (CurrentPropertyStatusId != 355) {
              if (this.propertyStatusList.find(data => data.id === CurrentPropertyStatusId).description.toLowerCase() == 'sold') {
                this.viewSoldDetailsLink = true
              }
            }
          }
        }
        this._loaderService.display(false);
        this.model.AutoCalcCapRate = x.AutoCalcCapRate;
        this.model.DisplayName = x.DisplayName;
        this.model.ShowDisplayName = x.ShowDisplayName;
        this.model.CharacteristicsId = x.CharacteristicsId;
        this.model.PropertyTypeList = x.PropertyTypeList;
        this.model.PropertyTypeSubcategoryList = x.PropertyTypeSubcategoryList;
        this.model.IsRentTermAutoCalc = x.IsRentTermAutoCalc;
        this.model.IsShowRentSchedule = x.IsShowRentSchedule;
        this.model.PropertyRentTerm = x.PropertyRentTerm;
        this.model.GuarantorId = x.GuarantorId;
        // portfoli
        this.model.PortfolioOriginalLeaseTerm = x.PortfolioOriginalLeaseTerm;
        this.model.PortfolioRemainingLeaseTerm = x.PortfolioRemainingLeaseTerm;
        this.model.IsPortfolio = x.IsPortfolio;
        this.model.AutoCalcPrice = x.AutoCalcPrice;
        this.model.PortfolioPropertyIds = x.PortfolioPropertyIds;
        this.model.OwnershipTypeIds = x.OwnershipTypeIds;
        this.model.LeaseStructureIds = x.LeaseStructureIds;
        this.model.NumberOfLocations = x.NumberOfLocations;
        this.model.NumberOfProperties = x.NumberOfProperties;
        this.model.InvestmentHighlights = x.InvestmentHighlights;
        this.model.AutoCalcCommencement = x.AutoCalcCommencement == null ? true : x.AutoCalcCommencement;
        this.model.AutoCalcLeaseExpiration = x.AutoCalcLeaseExpiration == null ? true : x.AutoCalcLeaseExpiration;
        this.model.AutoCalcLeaseType = x.AutoCalcLeaseType == null ? true : x.AutoCalcLeaseType;
        this.model.AutoCalcNumberOfLocations = x.AutoCalcNumberOfLocations == null ? true : x.AutoCalcNumberOfLocations;
        this.model.AutoCalcNumberOfProperties = x.AutoCalcNumberOfProperties == null ? true : x.AutoCalcNumberOfProperties;
        this.model.AutoCalcOptionLength = x.AutoCalcOptionLength == null ? true : x.AutoCalcOptionLength;
        this.model.AutoCalcOptionNumber = x.AutoCalcOptionNumber == null ? true : x.AutoCalcOptionNumber;
        this.model.AutoCalcOriginalLeaseTerm = x.AutoCalcOriginalLeaseTerm == null ? true : x.AutoCalcOriginalLeaseTerm;
        this.model.AutoCalcOwnershipType = x.AutoCalcOwnershipType == null ? true : x.AutoCalcOwnershipType;
        this.model.AutoCalcPortfolioSubcategory = x.AutoCalcPortfolioSubcategory == null ? true : x.AutoCalcPortfolioSubcategory;
        this.model.AutoCalcPortfolioType = x.AutoCalcPortfolioType == null ? true : x.AutoCalcPortfolioType;
        this.model.AutoCalcRemainingLeaseTerm = x.AutoCalcRemainingLeaseTerm == null ? true : x.AutoCalcRemainingLeaseTerm;
        this.model.AutoCalcRent = x.AutoCalcRent == null ? true : x.AutoCalcRent;
        this.model.AutoCalcRentalIncrease = x.AutoCalcRentalIncrease == null ? true : x.AutoCalcRentalIncrease;
        this.model.AutoCalcTenantType = x.AutoCalcTenantType == null ? true : x.AutoCalcTenantType;
        this.model.TenantTypeId = x.TenantTypeId;
        this.model.PropertySellers = x.PropertySellers;
        this.model.AutoCalcPrice = x.AutoCalcPrice == null ? true : x.AutoCalcPrice;
        this.model.AutoCalcBuildingSize = x.AutoCalcBuildingSize == null ? true : x.AutoCalcBuildingSize;
        this.model.IsOfferOnAllProperties = x.IsOfferOnAllProperties;

        if (this.model.PropertyForId == 602) {
          if (this.propertyStatusList.length > 0) {
            this.propertyStatusList.splice(this.propertyStatusList.findIndex(x => x.id == 349), 1);
            this.propertyStatusList.splice(this.propertyStatusList.findIndex(x => x.id == 350), 1);
          }
        }

        if (x.IsPortfolio) {
          this.loadPortfolioProperties();
        }
        // portfoli
      });
    }

  }

  reCalcRates(isChecked) {
    if (isChecked) {
      this.model.CapRate = parseFloat(((this.model.NOI / this.model.Price) * 100).toFixed(2));
    }
  }

  savePropertySaleHistory(saleDetails, res, objectTypeId) {
    if (res != null && res != undefined) {
      this.FileUpload.fileCategoryId = 0;
      this.FileUpload.id = res.Id;
      this.FileUpload.objectId = res.Id;
      this.FileUpload.objectTypeId = objectTypeId;
      this.FileUpload.type = "Documents";

      if (saleDetails.RemovedDocuments != null && saleDetails.RemovedDocuments.length > 0) {
        this._propertyManagementService.deleteMultipleDocument(saleDetails.RemovedDocuments, this.loggedUserDetails.Id).subscribe(res => {
          //this.closeModal();
          //this.reloadView()
        });
      }

      if (saleDetails.SelectedFiles != null && saleDetails.SelectedFiles != undefined && saleDetails.SelectedFiles.length > 0) {
        let index = 0;
        saleDetails.SelectedFiles.forEach(item => {
          this.FileUpload.documentName = item.name;
          var data = [];
          data.push(item);
          this._fileUploadService.uploadFiles(this.FileUpload, data).subscribe(response => {
            index++
            if (index == saleDetails.SelectedFiles.length) {
              //this.closeModal();
              //this.reloadView()
              //this._toastService.addToast({ title: 'Success', msg: 'Sale History Saved Successfully', timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
            }
          });
        });
      }
    }
  }

  checkValidation() {
    let result = true;
    if (this.model.TenantNameText == null && this.checkValue(this.model.TenantId, 1)) {
      result = false;
    }

    if (this.checkValue(this.model.Address, 2)) {
      result = false;
    }

    if (this.checkValue(this.model.StateId, 1)) {
      result = false;
    }

    if (this.checkValue(this.model.CityId, 1)) {
      result = false;
    }

    if (this.checkValue(this.model.Zip, 2)) {
      result = false;
    }

    if (this.checkValue(this.model.YearBuilt, 1) || this.model.YearBuilt < 1850) {
      result = false;
    }

    if (this.checkValue(this.model.PropertyTypeList, 2)) {
      result = false;
    }

    if (this.checkValue(this.model.BuildingSize, 1)) {
      result = false;
    }

    if (this.checkValue(this.model.PropertyForId, 1)) {
      result = false;
    }

    if (this.checkValue(this.model.NOI, 1)) {
      result = false;
    }

    if (this.checkValue(this.model.PricePSF, 1) && this.model.PropertyForId == 601) {
      result = false;
    }

    if (this.checkValue(this.model.LeaseCommencementDate, 3)) {
      result = false;
    }

    if (this.checkValue(this.model.LeaseExpiration, 3) || this.model.LeaseExpiration < this.model.LeaseCommencementDate) {
      result = false;
    }

    if (this.checkValue(this.model.OwnershipTypeId, 1)) {
      result = false;
    }

    if (!this.model.Unpriced) {
    if (this.checkValue(this.model.Price, 1)) {
      result = false;
      }
    }

    if (this.model.ShowDisplayName == true && this.checkValue(this.model.DisplayName, 2)) {
      result = false;
    }

    return result;
  }

  checkValue(value, type) {
    let result = false;
    switch (type) {
      case 1: // number
        if (value == null || value == undefined || value == 0) {
          result = true;
        }
        break;
      case 2: // string
        if (value == null || value == undefined || value.lenght == 0) {
          result = true;
        }
        break;
      case 3: // date 
        if (value == null || value == undefined || !(Object.prototype.toString.call(value) === "[object Date]" && isNaN(value.getTime()))) {
          result = false;
        }
        break;
    }

    return result;

  }

  portfolioSelectedProperties = [];
  propertySearchCriteria = {} as IPropertySearchCriteria;
  autoCalcAskingPrice(isCalc) {
    if (isCalc && this.model.IsPortfolio) {
      let price = this.portfolioSelectedProperties.map(x => x.Price);
      this.model.Price = price.reduce((a, b) => (a > 0 ? a : 0) + (b > 0 ? b : 0), 0);
      this.model.AutoCalcPSF = false;
      //this.reCalcRates(2, this.model.AutoCalcCapRate);
    }
    this.reCalcRates(this.model.AutoCalcCapRate);
  }

  loadPortfolioProperties() {
    this.propertySearchCriteria.PropertyId = this.model.Id;
    if (this.isDataEntryProperty) {
      this._propertyListingService.GetDataentryPortfolioPropertiesList(this.propertySearchCriteria).subscribe(item => {
        this.portfolioSelectedProperties = item;
      });
    }
    else {
      this._propertyListingService.GetPortfolioPropertiesList(this.propertySearchCriteria).subscribe(item => {
        this.portfolioSelectedProperties = item;
      });
    }
  }
}
